//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        website: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        return {
            activeGalleryName: 'main',
            toggleMediaGallery: false,
            selectedItem: {},
            folders: [{
                "title": "Home Left",
                "slug": "home_photo_gallery_left"
            }, {
                "title": "Home Right",
                "slug": "home_photo_gallery_right"
            }, {
                "title": "Amenities Left",
                "slug": "amenities_photo_gallery_left"
            }, {
                "title": "Amenities Right",
                "slug": "amenities_photo_gallery_right"
            }, {
                "title": "Floorplans Left",
                "slug": "floorplans_photo_gallery_left"
            }, {
                "title": "Floorplans Right",
                "slug": "floorplans_photo_gallery_right"
            }, {
                "title": "Neighborhood Left",
                "slug": "neighborhoods_photo_gallery_left"
            }, {
                "title": "Neighborhood Right",
                "slug": "neighborhoods_photo_gallery_right"
            }],
            images: []
            //			images: [ {
            //				"id": "0",
            //				"author": "Alejandro Escamilla",
            //				"width": 5616,
            //				"height": 3744,
            //				"url": "https://unsplash.com/photos/yC-Yzbqy7PY",
            //				"download_url": "https://picsum.photos/id/0/5616/3744"
            //			}, {
            //				"id": "1",
            //				"author": "Alejandro Escamilla",
            //				"width": 5616,
            //				"height": 3744,
            //				"url": "https://unsplash.com/photos/LNRyGwIJr5c",
            //				"download_url": "https://picsum.photos/id/1/5616/3744"
            //			} ]
        };
    },

    methods: {
        viewImgDetails: function viewImgDetails(img) {
            Event.$emit('open-slideout');

            this.selectedItem = img;
        },
        viewFolder: function viewFolder(folder) {
            console.log('viewFolder(folder) folder = ' + folder.slug);
            Event.$emit('view-folder', folder.slug);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/media/MediaMain.vue
// module id = U5X+
// module chunks = 0 1